import { P2PProviderType } from 'enums';
import {
  P2PProviderPayinConfig,
  P2PProviderPayoutLimits,
  P2PProviderFormValues,
  PayoutResponseTemplatesFormValues,
} from 'types';

const P2P_PROVIDER_BASE_CONFIG_VALUE: P2PProviderPayinConfig = {
  url: '',
  credentials: {
    apiKey: '',
    apiToken: '',
    signatureKey: '',
    password: '',
    apiSecret: '',
    apiPublic: '',
    apiPrivate: '',
    host2host: '',
  },
  enabled: false,
  pollingEnabled: false,
  responseTimeout: 0,
  expectedFee: 0,
  tradeMethods: [],
  orderMinAmount: 0,
  orderMaxAmount: 0,
  paymentTypeAmountLimits: {},
  configOverrides: {},
  useOwnPaymentType: false,
  ignoreWebhook: false,
};

const PAYIN_CONFIG_VALUE: P2PProviderPayinConfig = {
  ...P2P_PROVIDER_BASE_CONFIG_VALUE,
  intervalCommissions: [],
  allowCustomerBank: false,
  allowProviderAmountRandomization: false,
  activeDisputeCount: 0,
  dailyCustomerCompletedOrdersLimit: 0,
  cancelEnabled: false,
  failOnMissedMapping: null,
  useProviderPaymentUrl: false,
  keepNspkPhoneRequisites: false,
  collectCustomerReceipts: false,
};

const PAYOUT_RESPONSE_TEMPLATES_VALUE: PayoutResponseTemplatesFormValues = {
  statusFieldPath: '',
  acceptedStatuses: '',
  rejectedStatuses: '',
  requiredResponseFields: '',
  rejectedHttpStatusCodes: '',
  errorIndicators: '',
  acceptanceIndicators: '',
};

const PAYOUT_CONFIG_VALUE: P2PProviderFormValues['payoutConfig'] = {
  ...P2P_PROVIDER_BASE_CONFIG_VALUE,
  orderTimeout: 0,
  payoutResponseTemplates: PAYOUT_RESPONSE_TEMPLATES_VALUE,
};

const PAYOUT_LIMITS_VALUE: P2PProviderPayoutLimits = {
  limitSum: 0,
  limitCount: 0,
};

export const P2P_PROVIDER_INITIAL_VALUE: P2PProviderFormValues = {
  name: '',
  type: P2PProviderType.InternalLike,
  withdrawalFee: 0,
  maxBalance: 0,
  assetCurrencyId: '',
  fiatCurrencyId: '',
  currencyExchangeId: '',
  assetCurrencyExchangeId: null,
  payinConfig: PAYIN_CONFIG_VALUE,
  payoutConfig: PAYOUT_CONFIG_VALUE,
  payoutLimits: PAYOUT_LIMITS_VALUE,
  agents: [],
  comment: '',
};

export const P2P_PROVIDER_TYPES_WITH_NO_PAYOUT_PROTECTION = [
  P2PProviderType.InternalLike,
  P2PProviderType.ManualResolve,
];

export const P2P_PROVIDER_TYPES_WITHOUT_TRADE_METHODS = [
  P2PProviderType.ManualResolve,
];
